var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgToastWarninginline = function SvgToastWarninginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 10.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.884 9.333a.787.787 0 0 0-.787.788v5.249a.787.787 0 1 0 1.574 0v-5.25a.787.787 0 0 0-.787-.787ZM12.834 18.782a1.05 1.05 0 1 0 2.1 0 1.05 1.05 0 0 0-2.1 0Z",
    fill: "#FDB531"
  })));
};

export default SvgToastWarninginline;